(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[197],{

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(8828);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ CardNotFound; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7832);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1097);
/* harmony import */ var lib_amplitude__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1272);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6562);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3906);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);






const CardNotFound = ({ useSmallIcon =false , useMaxWidth =0 , ...props })=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    const { title , message , useButton , src , className =""  } = props;
    const pushToTrackEvents = (label)=>{
        switch(label){
            case "Mulai Belajar Gratis":
                (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_3__/* .trackEvent */ .L9)({
                    event: "myclass_startlearning_a"
                });
                break;
            case "Kembali ke Homepage":
                (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_3__/* .trackEvent */ .L9)({
                    event: "error_404_back_to_homepage_a"
                });
                break;
            case "Coba Lagi":
                (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_3__/* .trackEvent */ .L9)({
                    event: "error_500_retry_a"
                });
                router.reload();
                break;
            case "Kembali":
                (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_3__/* .trackEvent */ .L9)({
                    event: "error_500_back_a"
                });
                router.back();
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: `w-full flex ${useSmallIcon ? "flex-row justify-left" : "flex-col justify-center"} text-center gap-24 items-center m-auto ${className} ${useMaxWidth ? "bg-light_neutral10_to_dark_neutral50 min-h-[320px] rounded-8" : ""}`,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: src ? src : "/images/icon-not-found.png",
                alt: "",
                width: useSmallIcon ? 80 : 120,
                height: useSmallIcon ? 80 : 120
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `flex flex-col gap-24 ${useMaxWidth ? `max-w-[${useMaxWidth}px] px-16 md:px-0` : ""}`,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: `${useSmallIcon ? "grid align-center gap-4" : "flex flex-col gap-8"}`,
                        children: [
                            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: `text-b1 font-bold ${useSmallIcon ? "text-left" : ""}`,
                                children: title
                            }),
                            message && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: `text-b2 font-medium text-neutral-60 ${useSmallIcon ? "text-left" : ""}`,
                                children: message
                            })
                        ]
                    }),
                    useButton && useButton.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-center " + (useButton.length > 1 ? "gap-8" : ""),
                        children: useButton.map((el)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                href: el.href,
                                onClick: ()=>{
                                    pushToTrackEvents(el.label);
                                    if (el.onClose) {
                                        el.onClose();
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    size: "medium",
                                    isFull: true,
                                    //@ts-ignore
                                    variant: el.variant ? el.variant : "primary",
                                    children: el.label
                                })
                            }, "useButton" + el.href))
                    }) : null
                ]
            })
        ]
    });
};


/***/ }),

/***/ 8828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ _404; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(6734);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(1774);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./src/components/Card/CardNotFound.tsx
var CardNotFound = __webpack_require__(7313);
;// CONCATENATED MODULE: ./src/pages_web/404.tsx




const NotFoundData = [
    {
        id: "500",
        title: "Ups, Ada Gangguan yang Terjadi",
        message: "Kami sedang membereskan masalah ini. Silahkan kembali ke halaman sebelumnya atau mencoba sesaat lagi",
        src: "/images/icon-warning.png",
        useButton: [
            {
                href: "/",
                label: "Kembali",
                variant: "secondary_transparant"
            },
            {
                href: "/",
                label: "Coba Lagi"
            }
        ]
    },
    {
        id: "404",
        title: "Halaman Tidak Ditemukan",
        message: null,
        src: "/images/icon-404.png",
        useButton: [
            {
                href: "/",
                label: "Kembali ke Homepage"
            }
        ]
    }
];
const Page404 = ()=>{
    const notFoundProps = NotFoundData.find((x)=>x.id === "404");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                className: "h-screen !max-w-[100vw] flex justify-center px-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardNotFound/* CardNotFound */._, {
                    ...notFoundProps
                })
            })
        })
    });
};
/* harmony default export */ var _404 = (Page404);

;// CONCATENATED MODULE: ./src/pages/404.tsx



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [422,562,541,774,888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);